<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="568" scrollable>
      <v-card class="grid">
        <!-- close -->
        <v-toolbar elevation="0" class="title">
          <span class="pl-2">{{ $t('message.pages.paymentModal.title') }}</span>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- steps -->
        <v-card-text class="mt-4" style="height: 450px">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="12">
              <v-row no-gutters align="center" justify="center">
                <v-btn
                  class="elevation-0"
                  width="200px"
                  color="primary"
                  style="
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                  "
                  :outlined="!isCard"
                  @click="handleCard"
                >
                  <span class="btnText">{{
                    $t('message.pages.userPlan.creditCard')
                  }}</span>
                </v-btn>
                <v-btn
                  v-if="isBrlPayment"
                  class="elevation-0"
                  width="200px"
                  color="primary"
                  style="
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                  "
                  :outlined="isCard"
                  @click="handleBoleto"
                >
                  <span class="btnText">{{
                    $t('message.pages.userPlan.ticket')
                  }}</span>
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="isCard">
              <v-row no-gutters align="center" justify="center">
                <v-col cols="8" class="mt-8">
                  <span class="fieldText textType--text">{{
                    $t('message.pages.paymentModal.cardNumber')
                  }}</span>
                </v-col>
                <v-col cols="8" class="mt-1" style="margin-bottom: 366px">
                  <stripe-element-card
                    :key="stripeLocale"
                    id="planStripeCard"
                    ref="planStripeCard"
                    :hidePostalCode="true"
                    :pk="stripeKeyByCountry"
                    :locale="stripeLocale"
                    @token="handleToken"
                    @error="handleStripeError"
                    @keydown.enter="() => {}"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-else>
              <v-row no-gutters align="center" justify="center">
                <v-col cols="8" class="mt-6"> CPF/CNPJ </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="user.document"
                    v-mask="documentMask"
                    outlined
                    dense
                    :messages="documentErrorMessage"
                    :error="errors.invalidCnpj || errors.invalidCpf"
                  >
                    <template v-slot:message="{ message }">
                      <span
                        class="red--text caption align-text"
                        v-if="errors.invalidCnpj || errors.invalidCpf"
                      >
                        <v-icon color="red" size="18" class="pb-1">
                          mdi-alert-circle</v-icon
                        >
                        {{ message }}
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="8"> CEP </v-col>
                <v-col cols="8" class="d-flex flex-row justify-end">
                  <v-text-field
                    v-model="address.postal_code"
                    :loading="validatingCEP"
                    v-mask="'#####-###'"
                    placeholder="Ex: 12345000"
                    outlined
                    dense
                    maxlength="9"
                    :disabled="validatingCEP"
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  {{ $t('message.pages.profile.state') }}
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="address.state"
                    :disabled="validatingCEP"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="8"> {{ $t('message.pages.profile.city') }} </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="address.city"
                    :disabled="validatingCEP"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  {{ $t('message.pages.profile.address') }}
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="address.line1"
                    :disabled="validatingCEP"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-6 pr-10">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="12" v-if="errors.fetchError">
              <v-card
                flat
                class="mb-4"
                style="
                  display: flex;
                  justify-content: center;
                  text-align: center;
                "
              >
                <span
                  class="error--text text-body-2 align-text d-block"
                  style="width: 85%"
                >
                  {{ errors.shownErrMsg }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="18" v-bind="attrs" v-on="on">
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <v-container
                      class="text-body-2 pa-0"
                      style="max-width: 230px"
                    >
                      {{ errors.tooltipErrMsg }}
                    </v-container>
                  </v-tooltip>
                </span>
              </v-card>
            </v-col>
            <v-col cols="8" class="mb-4">
              <v-btn
                color="primary"
                block
                :loading="isFetchingSave"
                :disabled="!checkFormValid"
                @click="handleSaveMethod"
              >
                {{ $t('message.actions.save') }}
                {{
                  isCard
                    ? $t('message.pages.userPlan.card')
                    : $t('message.pages.userPlan.ticket')
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import planApi from '@/services/planApi'
import { mapState } from 'vuex'
import { IS_CPF, IS_CNPJ } from '@/config/envs.js'
import addressApi from '@/services/addressApi'
import i18n from '@/translations/lang'
import Storage from '../../../utils/Storage'

export default {
  name: 'AddPaymentModal',
  components: {
    StripeElementCard,
  },
  data: () => ({
    open: false,
    isCard: true,
    stripeKey: process.env.VUE_APP_STRIPE_API,
    stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
    stripeLocale: 'pt-BR',
    cardToken: '',
    user: {
      document: '',
    },
    address: {
      city: '',
      country: 'BR',
      line1: '',
      postal_code: '',
      state: '',
    },
    errors: {
      invalidCnpj: false,
      invalidCpf: false,
      fetchError: false,
      shownErrMsg: '',
      tooltipErrMsg: '',
    },
    cardErrors: {
      declined: false,
      default: false,
      expired: false,
    },
    validatingCEP: false,
    firstRequest: true,
    isFetchingSave: false,
    states: [
      { id: 12, UF: 'AC' },
      { id: 27, UF: 'AL' },
      { id: 16, UF: 'AP' },
      { id: 13, UF: 'AM' },
      { id: 29, UF: 'BA' },
      { id: 23, UF: 'CE' },
      { id: 53, UF: 'DF' },
      { id: 32, UF: 'ES' },
      { id: 52, UF: 'GO' },
      { id: 21, UF: 'MA' },
      { id: 51, UF: 'MT' },
      { id: 50, UF: 'MS' },
      { id: 31, UF: 'MG' },
      { id: 15, UF: 'PA' },
      { id: 25, UF: 'PB' },
      { id: 41, UF: 'PR' },
      { id: 26, UF: 'PE' },
      { id: 22, UF: 'PI' },
      { id: 33, UF: 'RJ' },
      { id: 24, UF: 'RN' },
      { id: 43, UF: 'RS' },
      { id: 11, UF: 'RO' },
      { id: 14, UF: 'RR' },
      { id: 42, UF: 'SC' },
      { id: 35, UF: 'SP' },
      { id: 28, UF: 'SE' },
      { id: 17, UF: 'TO' },
    ],
  }),
  computed: {
    ...mapState('user', ['userPlanInfo']),
    stripeKeyByCountry() {
      if (this.userPlanInfo?.currency === 'brl') return this.stripeKey
      return this.stripeKeyUS
    },
    isBrlPayment() {
      return this.userPlanInfo?.currency === 'brl'
    },
    documentMask() {
      const doc = this.user.document
      if (doc.length > 14) {
        return ['##.###.###/####-##']
      } else {
        return ['###.###.###-##']
      }
    },
    computedCep() {
      return this.address.postal_code
    },
    documentErrorMessage() {
      if (this.errors.invalidCpf) {
        return 'CPF inválido'
      }
      if (this.errors.invalidCnpj) {
        return 'CNPJ inválido'
      }
      return ''
    },
    checkFormValid() {
      if (this.isCard) return true
      return (
        !!this.user.document &&
        !!this.address.postal_code &&
        !!this.address.line1 &&
        !!this.address.state &&
        !!this.address.city
      )
    },
  },
  watch: {
    computedCep(oldVal, newVal) {
      if (this.unmask(oldVal) === this.unmask(newVal)) return
      const cepNumber = this.unmask(this.address.postal_code)
      if (cepNumber.length === 8 && !this.firstRequest) {
        this.searchCep()
      }
      this.firstRequest = false
    },
  },
  mounted() {
    this.setStripeLocale()
    this.$root.$on('changeLanguage', () => {
      this.setStripeLocale()
    })
    this.$root.$on('openAddPaymentModal', () => {
      this.isCard = true
      this.firstRequest = true
      this.open = true
      this.user.document =
        JSON.parse(JSON.stringify(this.userPlanInfo.taxId.value)) ?? ''
      if (this.userPlanInfo.address)
        this.address = JSON.parse(JSON.stringify(this.userPlanInfo.address))
    })
  },
  beforeDestroy() {
    this.$root.$off('changeLanguage')
    this.$root.$off('openAddPaymentModal')
  },
  methods: {
    handleFetchError(err) {
      this.errors.fetchError = true
      this.errors.tooltipErrMsg =
        err.msg ??
        err.response.data.errDeclineCode ??
        err.response.data.errMsg ??
        err.response.data.message ??
        'Error'

      this.errors.shownErrMsg =
        i18n.t(`message.errorStripe.${this.errors.tooltipErrMsg}`) ??
        i18n.t('message.errors.unexpectedError')
    },
    handleStripeError() {
      this.isFetchingSave = false
    },
    handleSaveMethod() {
      if (this.isCard) {
        this.isFetchingSave = true
        this.$refs.planStripeCard.submit()
      } else {
        this.handleAddBoleto()
      }
    },
    async addCardToUser(cardToken) {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      try {
        let ret = await planApi.addCard(cardToken)
        this.$root.$emit('updateSources', ret.data)
        this.handleClose()
        this.isCard = false
        this.isFetchingSave = false
      } catch (e) {
        this.isFetchingSave = false
        this.handleFetchError(e)
        switch (e.response.data.errMsg) {
          case 'card_declined':
            this.cardErrors.declined = true
            break
          case 'expired_card':
            this.cardErrors.expired = true
            break
          default:
            this.cardErrors.default = true
            break
        }
      }
    },
    async handleAddBoleto() {
      this.isFetchingSave = true
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      const doc = this.unmask(this.user?.document)
      if (!doc || (doc?.length !== IS_CNPJ && doc?.length !== IS_CPF)) {
        this.errors.invalidCpf = true
        this.isFetchingSave = false
        return
      }
      if (doc?.length === IS_CPF) {
        const isValid = this.isValidCPF(doc)
        if (!isValid) {
          this.errors.invalidCpf = true
          this.isFetchingSave = false
          return
        }
      }
      if (doc?.length === IS_CNPJ) {
        const isValidCNPJ = this.isValidCNPJ(doc)
        if (!isValidCNPJ) {
          this.errors.invalidCnpj = true
          this.isFetchingSave = false
          return
        }
      }
      let boleto = {
        tax_id: this.user.document,
        name: this.userPlanInfo.user.name,
        email: this.userPlanInfo.user.email,
        address1: this.address.line1,
        city: this.address.city,
        state: this.address.state,
        postal_code: this.address.postal_code,
        country: 'BR',
      }
      try {
        let ret = await planApi.addBoleto(boleto)
        this.$root.$emit('updateSources', ret.data)
        this.handleClose()
      } catch (error) {
        this.handleFetchError(error)
        this.isFetchingSave = false
        console.log(error)
      }
    },
    async handleToken(token) {
      this.isFetchingSave = true
      this.cardToken = token
      try {
        await this.addCardToUser(token)
      } catch (error) {
        this.isFetchingSave = false
        console.log(error)
      }
    },
    async searchCep() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.validatingCEP = true
      const cepNumber = this.unmask(this.address.postal_code)
      if (cepNumber.length === 8) {
        try {
          const ret = await addressApi.getCep(cepNumber)
          this.address.line1 = ret.data.address
          this.address.city = ret.data.name
          const stateFound = this.states.filter((state) => {
            return state.id === ret.data.state_id
          })
          this.address.state = stateFound[0].UF
        } catch (e) {
          this.errors.errMsgCep = e.response.data.errMsg
          this.errors.unknownCepError = true
          this.validatingCEP = false
          console.error(e)
        }
      }
      this.validatingCEP = false
    },
    unmask(text) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/
      return text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text
    },
    isValidCPF(cpf) {
      if (typeof cpf !== 'string') return false
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf.length !== IS_CPF || !!cpf.match(/(\d)\1{10}/)) return false
      cpf = cpf.split('')
      const validator = cpf
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        .map((el) => +el)
      const toValidate = (pop) =>
        cpf
          .filter((digit, index, array) => index < array.length - pop && digit)
          .map((el) => +el)
      const rest = (count, pop) =>
        ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
          10) %
          11) %
        10
      return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
    },
    isValidCNPJ(cnpj) {
      if (
        !cnpj ||
        cnpj.length != 14 ||
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false
      let length = cnpj.length - 2
      let numbers = cnpj.substring(0, length)
      let digits = cnpj.substring(length)
      let sum = 0
      let pos = length - 7
      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--
        if (pos < 2) pos = 9
      }
      let result = sum % IS_CPF < 2 ? 0 : 11 - (sum % IS_CPF)
      if (result != digits.charAt(0)) return false
      length = length + 1
      numbers = cnpj.substring(0, length)
      sum = 0
      pos = length - 7
      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--
        if (pos < 2) pos = 9
      }
      result = sum % IS_CPF < 2 ? 0 : IS_CPF - (sum % IS_CPF)
      if (result != digits.charAt(1)) return false
      return true
    },
    handleCard() {
      this.isCard = true
    },
    handleBoleto() {
      this.errors.shownErrMsg = ''
      this.isCard = false
      this.errors.fetchError = false
    },
    handleClose() {
      this.open = false
      this.errors.shownErrMsg = ''
      this.errors.fetchError = false
    },
    setStripeLocale() {
      const lang = Storage.getItem('locale')
      if (lang) {
        this.stripeLocale = lang === 'pt' ? 'pt-BR' : lang
        this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 18px;
}
.btnText {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
}
.fieldText {
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
}
</style>
